import type { TranslationMessages } from '../types';

export const customer_reviews: TranslationMessages = {
        name: 'Đánh giá khách hàng |||| Đánh giá khách hàng',
      };
